import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import TransactionAlreadyPaid from "./TransactionAlreadyPaid";
import TransactionAlreadyPaid1xbet from "./TransactionAlreadyPaid1xbet";

function TransactionAlreadyPaidIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? (
    <TransactionAlreadyPaid1xbet {...props} />
  ) : (
    <TransactionAlreadyPaid {...props} />
  );
}

export default TransactionAlreadyPaidIndex;
